import { put, call, takeLatest, select } from 'redux-saga/effects'
import startOfDay from 'date-fns/startOfDay'
import subMonths from 'date-fns/subMonths'

import { companyId } from '@/core/selectors/sessions'
import * as hiringAnalyticsView from '../reducks/hiringAnalytics'
import { getDeclineReasons } from '@/core/apiModules/hiringAnalytics'
import { getStaticDeclineReasons } from '@/core/apiModules/staticDeclineReasons'
import { errorHandler } from '@/core/helpers/errorHelpers'
import { showSystemError, hideSystemError } from '@/core/components/SystemErrorRedux'

function* fetchDeclineReasons() {
  try {
    yield put(hideSystemError())

    const id = yield select(companyId)
    const response = yield call(getDeclineReasons, id, { start_at: subMonths(startOfDay(new Date()), 6) })
    yield put(hiringAnalyticsView.fetchDeclineReasonsSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(hiringAnalyticsView.fetchDeclineReasonsError(error))

    yield put(showSystemError(error))
  }
}

function* fetchStaticDeclineReasons() {
  try {
    yield put(hideSystemError())

    const response = yield call(getStaticDeclineReasons)
    yield put(hiringAnalyticsView.fetchStaticDeclineReasonsSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(hiringAnalyticsView.fetchStaticDeclineReasonsError(error))

    yield put(showSystemError(error))
  }
}

export default function* watchDeclineReasonsSaga() {
  yield takeLatest(hiringAnalyticsView.FETCH_DECLINE_REASONS, fetchDeclineReasons)
  yield takeLatest(hiringAnalyticsView.FETCH_STATIC_DECLINE_REASONS, fetchStaticDeclineReasons)
}
